var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"px-0 py-0",attrs:{"fluid":""}},[_c('v-card',{attrs:{"loading":_vm.loading}},[_c('v-card-text',{staticClass:"pb-0"},[_c('iframe',{attrs:{"frameborder":"0","width":"100%","height":_vm.iframeHeight,"src":_vm.iframeUrl},on:{"load":_vm.onIframeLoad}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }